"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, type CSSProperties, type ReactNode } from "react";
import { cn } from "@/lib/utils";
import styles from "./card.module.scss";
export function Card(t0) {
  const $ = _c(48);
  const {
    children,
    title,
    titleIcon,
    accentColor,
    hoverBorderColor,
    onHoverChange,
    titleTone,
    titleRight,
    titleInfo,
    className,
    style,
    headerVariant: t1
  } = t0;
  const headerVariant = t1 === undefined ? "default" : t1;
  const [hovered, setHovered] = useState(false);
  const accentHeader = Boolean(titleIcon);
  const titleUsesAccent = accentHeader && (titleTone ?? "accent") === "accent";
  const accent = accentColor ?? "#cfd604";
  const showHoverBorder = Boolean(hoverBorderColor);
  let t2;
  if ($[0] !== accent) {
    t2 = {
      "--card-accent": accent
    };
    $[0] = accent;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const cssVars = t2 as CSSProperties;
  const t3 = showHoverBorder && styles.rootHoverBorder;
  let t4;
  if ($[2] !== className || $[3] !== t3) {
    t4 = cn(styles.root, t3, className);
    $[2] = className;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== hoverBorderColor || $[6] !== hovered || $[7] !== showHoverBorder) {
    t5 = showHoverBorder && hovered ? {
      borderColor: hoverBorderColor
    } : undefined;
    $[5] = hoverBorderColor;
    $[6] = hovered;
    $[7] = showHoverBorder;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== cssVars || $[10] !== style || $[11] !== t5) {
    t6 = {
      ...cssVars,
      ...style,
      ...t5
    };
    $[9] = cssVars;
    $[10] = style;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  let t8;
  if ($[13] !== onHoverChange || $[14] !== showHoverBorder) {
    t7 = () => {
      if (showHoverBorder) {
        setHovered(true);
      }
      onHoverChange?.(true);
    };
    t8 = () => {
      if (showHoverBorder) {
        setHovered(false);
      }
      onHoverChange?.(false);
    };
    $[13] = onHoverChange;
    $[14] = showHoverBorder;
    $[15] = t7;
    $[16] = t8;
  } else {
    t7 = $[15];
    t8 = $[16];
  }
  const t9 = headerVariant === "overview" && styles.headerRowOverview;
  let t10;
  if ($[17] !== t9) {
    t10 = cn(styles.headerRow, t9);
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== titleIcon) {
    t11 = titleIcon ? <span className={styles.titleIcon} aria-hidden={true}>{titleIcon}</span> : null;
    $[19] = titleIcon;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = titleUsesAccent ? styles.titleAccent : styles.titleNeutral;
  let t13;
  if ($[21] !== t12) {
    t13 = cn(styles.title, t12);
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13 || $[24] !== title) {
    t14 = <h3 className={t13}>{title}</h3>;
    $[23] = t13;
    $[24] = title;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  const t15 = titleInfo ?? null;
  let t16;
  if ($[26] !== t11 || $[27] !== t14 || $[28] !== t15) {
    t16 = <div className={styles.titleGroup}>{t11}{t14}{t15}</div>;
    $[26] = t11;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== titleRight) {
    t17 = titleRight ? <div className={styles.titleRight}>{titleRight}</div> : null;
    $[30] = titleRight;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t10 || $[33] !== t16 || $[34] !== t17) {
    t18 = <div className={t10}>{t16}{t17}</div>;
    $[32] = t10;
    $[33] = t16;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className={styles.divider} />;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t18) {
    t20 = <div className={styles.header}>{t18}{t19}</div>;
    $[37] = t18;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== children) {
    t21 = <div className={styles.body}>{children}</div>;
    $[39] = children;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== t20 || $[42] !== t21 || $[43] !== t4 || $[44] !== t6 || $[45] !== t7 || $[46] !== t8) {
    t22 = <div className={t4} style={t6} onPointerEnter={t7} onPointerLeave={t8}>{t20}{t21}</div>;
    $[41] = t20;
    $[42] = t21;
    $[43] = t4;
    $[44] = t6;
    $[45] = t7;
    $[46] = t8;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  return t22;
}